<template>
    <div class="bulkCallsVue">
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable" v-loading="loading">

                <div class="bulk-table-outer">
                    <div class="c-common-space">
                        <div class="o-subtitleHeading">
                            <label class="o-blue-regular-text">Group by:</label>
                            <span>
                                <div class="checkbox o-custom-radio">
                                    <label>
                                        Start time
                                        <input type="checkbox" id="checkbox" @change="onInputChangeCheckbox" v-model="callsFilter.start">
                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                    </label>
                                </div>
                            </span>
                            <span>
                                <div class="checkbox o-custom-radio">
                                    <label>
                                        End time
                                        <input type="checkbox" nid="checkbox" @change="onInputChangeCheckbox" v-model="callsFilter.end">
                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                    </label>
                                </div>
                            </span>
                            <span>
                                <div class="checkbox o-custom-radio">
                                    <label>
                                        Position
                                        <input type="checkbox" id="checkbox" @change="onInputChangeCheckbox" v-model="callsFilter.position">
                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                    </label>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="bulk-table-outer" v-for="(dateWiseCalls, key, index) in calls" :key="key">
                    <div class="c-common-space o-individual-calls">

                        <div class="col-md-12 o-no-padding">
                            <!-- <h5 :id="'element'+index" class="h5"><i class="fa fa-calendar-o" aria-hidden="true"></i> {{getDate(key)}}</h5> -->
                            <!-- <h5 class="h5 normal-font">Demo Text</h5>
                            <a href="javascript: void(0)" class="c-common-btn c-common-btn--small"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a> -->
                            <!-- <a :class="{'isDisabled':!getPower('cloneCall')}" href="javascript: void(0)" @click="openCloneModal(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Clone</a>
                            <a :class="{'isDisabled':!getPower('cloneCall')}" href="javascript: void(0)" @click="openAdvanceClone(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a>
                            <a :class="{'isDisabled':!getPower('deleteCall')}" href="javascript: void(0)" @click="deleteCallsByDate(dateWiseCalls)" class="c-common-btn c-common-btn--small"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a> -->


                            <!-- <div class="custom-col outer--border text-center"> -->
                            <div class="c-common-space o-individual-calls">

                                <div class="custom-row o-no-padding">
                                    <h5 :id="'element'+index" class="h5"><i class="fa fa-calendar-o" aria-hidden="true"></i> {{getDate(key)}}</h5>
                                    <a href="javascript: void(0)" v-if="jobAccessStatus != 'View Access'" @click="openCloneModal(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Clone</a>
                                    <a href="javascript: void(0)" v-if="jobAccessStatus != 'View Access'" @click="openAdvanceClone(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a>

                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Jump to day:</label>
                                        <select @change="onSelectScrollTo($event)" v-model="selectedScrollDate" class="form-control">
                                            <option v-for="(call, key, index) in calls" :key="key" v-if="call.length>0" :value="'#element'+index" >{{getDateScrollTO(key)}}</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>

                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Sort by:</label>
                                        <select v-model="selectedSortType" class="form-control" @change="changeSortType">
                                            <option value="start">Start time</option>
                                            <option value="skill">Skill</option>
                                            <option value="status">Unassigned</option>
                                            <!-- <option value="seniority">Seniority</option> -->
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>

                                    <div class="custom-col text-right float-right">
                                        <!-- :class="job && job.client && job.client.employer && job.client.employer[0].status && job.client.employer[0].status.name !='View Access' -->
                                        <a  href="javascript: void(0)" @click="addBulkCall(key)" class="c-solid-btn c-solid-btn--large c-solid-btn--green" :class="job && job.client && job.client.employer && job.client.employer[0].status && job.client.employer[0].status.name !='View Access'?'c-solid-btn c-solid-btn--large c-solid-btn--green':'c-solid-btn c-solid-btn--large c-solid-btn--green disabled'"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Start new tabular structure -->                  
                    <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                        <thead>
                            <tr>
                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10">
                                    <span class="o-no-margin-bottom">Start time</span>
                                </th>
                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right">
                                    <span class="o-no-margin-bottom">End time</span>
                                </th>
                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10">
                                    <span class="o-no-margin-bottom">Position</span>
                                </th>
                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right">
                                    <span class="o-no-margin-bottom">Employee</span>
                                </th>
                            
                                <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10  text-center table-td-border-right">
                                    <el-tooltip class="item" effect="dark" content="Assigned/Unassigned" placement="top-end">
                                        <span class="o-no-margin-bottom">A/U</span>
                                    </el-tooltip>
                                </th>
                            
                                <th align="center" valign="top" class="o-accordion-subtext u-cmn-padding10  text-center table-td-border-right">
                                    <span class="o-no-margin-bottom"></span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(call, id) in dateWiseCalls" :key="id">
                                <td :id="'backTo'+index+id" align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                    <p v-if="callsFilter.start">{{getTime(call.start)}}</p>
                                    <p v-else v-for="(singleCall, inxd) in call.call" :key="inxd">{{getTime(singleCall.start)}}</p>
                                </td>
                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                    <p v-if="callsFilter.end">{{getTime(call.end)}}</p>
                                    <p  v-else v-for="(singleCall, inxd) in call.call" :key="inxd">{{getTime(singleCall.end)}}</p>
                                </td>
                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                    <p v-if="callsFilter.position">{{call.skills[0].name}}({{call.skills[0].priotiy}})</p>
                                    <p v-else v-for="(skill, inxd) in call.skills" :key="inxd">{{skill.name}}({{skill.priotiy}})</p>
                                </td>
                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                    <p v-for="(singleCall, inxd) in call.call" v-if="singleCall && singleCall.employee" :key="inxd" :class="{'text-danger':singleCall.employee.deleted_at}">
                                        <span v-if="singleCall.employee&&singleCall.employee.employable">
                                            <span>
                                                {{singleCall.employee.employable.last_name +", "+singleCall.employee.employable.first_name+(singleCall.employee.seniority?"("+ getRoundOffSkillSeniority(singleCall.employee.seniority) +")":'')}}
                                            </span>
                                            
                                            <el-tooltip class="item" effect="dark" content="Confirmed" placement="top-end">
                                                <i v-if="singleCall.status.name=='Confirmed'" class="fa fa-check confirm-check-icon-style" aria-hidden="true"></i>
                                            </el-tooltip>
                                        </span>
                                    </p>
                                </td>                      
                                
                                <!-- <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5  text-center">
                                    <p>{{call.assigned}}</p>
                                </td> -->
                                <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5  text-center table-td-border-right">
                                    <!-- :class="{'isDisabled':!getPower('phoneSheetActions')}" -->
                                    <p>{{call.assigned}}/<span :class="{'unassigned-calls-number': call.unassigned }" >{{call.unassigned}} </span></p>
                                </td>
                                <!-- <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center">
                                    <p v-if="noteBtnActive(call)" >
                                        <a @click="goToViewEmployee(call)" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width">
                                            <i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-eye"></i> View Notes
                                        </a>
                                    </p>
                                    <p v-else>- - -</p>
                                </td> -->
                                <!-- <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center table-td-border-right">
                                    <p>
                                        <a :class="{'disabled':!callsFilter.start || !callsFilter.end || !callsFilter.position}" @click="bulkAssign(call, 'backTo'+index+id)" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width">
                                            <i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-plus-circle"></i> Bulk Assign
                                        </a>
                                    </p>
                                </td> -->
                                <td align="center" valign="top" class="table-td-border-top u-cmn-padding5 w-100">
                                    <!-- <div class="fontsize-0"> -->
                                        <!-- <a data-v-d8a8ddae="" href="javascript: void(0)" class="float-none edit-del"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-cutlery"></i></a> -->
                                        <!-- <a @click="editBulk(call)" :class="{'disabled':!getPower('editCall')}" href="javascript: void(0)" class="float-none edit-del"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-pencil"></i></a>
                                        <a @click="deleteBulkCall(call)" :class="{'disabled':!getPower('deleteCall')}" href="javascript: void(0)" class="float-none edit-del"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-trash-o"></i></a> -->
                                    <!-- </div> -->

                                    <div class="fontsize-0">
                                        <!-- <div class="o-edit-trash o-no-padding"> -->

                                            <div class="o-table-block-btn"> 
                                                <a href="javascript: void(0)" @click="editBulk(call)" :class="checkCallEditStatus(call.unassigned)?'':'disabled'"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                            </div>
                                            <div class="o-table-block-btn">
                                                <a href="javascript: void(0)" @click="deleteBulkCall(call)" :class="checkCallEditStatus(call.unassigned)?'':'disabled'"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                            </div>

                                        <!-- </div> -->
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- End new tabular structure -->
                </div>            
            </div>

        </div>

        <modal name="edit-bulk"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeEditBulk()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Edit Bulk</h1>
                        </div>
                        <div class="c-common-box-shadow c-bg-white o-margin-top15">
                        <div class="row">
                            <div class="col-md-12 ">
                                <h1 class="o-modal-head">Current gouping parameters:</h1>
                            </div>
                            <div class="col-md-12">
                                <div class="o-modal-doc-cont">
                                    <ul class="o-documents-container o-documents-container--modal o-bulk-edit-list">
                                        <li v-if="callsFilter.start">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>Start Time:</span> {{getGlobalDate(editBulkcall.startDate) +" "+ editBulkcall.startTime}}
                                            </div>
                                        </li>
                                        <li v-if="callsFilter.end">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>End Time:</span> {{getGlobalDate(editBulkcall.endDate)+" "+ editBulkcall.endTime}}
                                            </div>
                                        </li>
                                        <li v-if="callsFilter.position">
                                            <div class="col-md-12 o-no-padding o-bulk-edit-list-item">
                                                <span>Position:</span> {{editBulkcall.skillNane}}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                                <div class="row">
                                    <!-- <div class="col-sm-12 o-modal-field-area">
                                    <h2 class="h2 text-center o-modal-link">{{callIds.length}} calls will be affected</h2>
                                    </div> -->
                                    <!-- <div v-if="callsFilter.start" class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Start Date:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="o-cutsomSelect">
                                                <select v-model="editBulkcall.endDate" class="form-control">
                                                <option value="">---- Select Start Date ----</option>
                                                <option v-for="dayCall in callDaysForJob" :value="extractDateOnly(dayCall.date)">{{getGlobalDate(dayCall.date)}}</option>
                                                </select>
                                        </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div v-if="callsFilter.start" class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Start Time:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">

                                        <date-picker name="Start" v-validate="{required: true}" v-model="editBulkcall.startTime" :config="config" placeholder="Select Time"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div v-if="callsFilter.end" class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">End Date:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="o-cutsomSelect">
                                                <select v-model="editBulkcall.endDate" class="form-control">
                                                <option value="">---- Select End Date ----</option>
                                                <option v-for="dayCall in callDaysForJob" :value="extractDateOnly(dayCall.date)">{{getGlobalDate(dayCall.date)}}</option>
                                                </select>
                                        </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div v-if="callsFilter.end" class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">End Time:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <date-picker name="End" v-validate="{required: true}" v-model="editBulkcall.endTime" :config="config" placeholder="Select Time"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div v-if="callsFilter.position" class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Position:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">

                                        <div class="o-cutsomSelect">
                                            <select v-model="editBulkcall.skill" class="form-control">
                                                    <option value="">---- Select Position ----</option>
                                                <option v-for="position in positions" :value="position.id">{{position.name}}</option>
                                            </select>
                                        </div>

                                        </div>
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Rate:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div>
                                                <input type="number" v-model="editBulkcall.rate" class="form-control">
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Notes:</label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div>
                                                <textarea  type="textarea" v-model="editBulkcall.notes" class="form-control"></textarea>
                                        </div>
                                        </div>
                                    </div>
                                </div>


                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEditBulk()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveEditCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    <!-- /.modal-content -->
                </div>

                <!-- /.modal-dialog -->
            </div>
        </modal>
        <modal name="call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeCloneModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Basic Bulk Clone</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h2 class="h2 text-center">{{selectedJobTitle}}</h2>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <hr class="o-modal-separetor" />
                                        </div>
                                    </div>
                                    <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                        <p class="ps2">This routine will duplicate all calls from the source date to another day within the same job. All calls already existing in that day will be deleted, so this tool should be used before adding additional calls that are not sourced from the original date.</p>
                                        <p class="ps2">To clone days to a date outside of the job's scope, it will be necessary to edit the job and extend the end date, otherwise the date will not appear in the dropdown box.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls from:</label>
                                        <label class="common-label-input">
                                            {{getGlobalDate(cloneData.cloneFrom)}}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls to:</label>
                                        <label class="common-label-input">
                                            <!-- <el-col :span="50">
                                            <el-date-picker
                                                name="date"
                                                class="custom_date"
                                                v-validate="{ required: true}"
                                                v-model="cloneData.closeTo"
                                                type="date"
                                                :picker-options="pickerOptions"
                                                format="yyyy/MM/dd"
                                                value-format="yyyy-MM-dd"
                                                placeholder="Pick a day">
                                            </el-date-picker>
                                            </el-col> -->
                                            <select class="form-control" v-model="cloneData.closeTo">
                                                <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.date">{{getGlobalDate(callDay.date)}}</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>


                            <!--  <div class="col-sm-12">
                                    <div class="form-group ">
                                        <label class="common-label-text">Copy assignments?</label>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input type="checkbox" id="checkbox" v-model="cloneData.assignments">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div> -->

                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeCloneModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="cloneCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                </li>
                            </ul>
                        </div>


                    </div>
                    <!-- /.modal-content -->
                </div>
            </div>
        </modal>
        <modal name="advance-call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-lg o-large-modal">
            <div id="" tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeAdvanceClone()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Advance Bulk Clone Call</h1>
                        </div>
                        <div class="c-common-box-shadow o-modal-body c-margin-bottom-10">
                            <div class="row">
                                <div class="col-sm-6">
                                        <div class="form-group o-no-margin">
                                            <label class="common-label-text">Clone From:</label>
                                            <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="advanceCloneData.callUnderSelectedDay">
                                                    <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.calls" v-if="(callDay.calls.length>0)? true : false" v-bind:selected="key === 0">{{getGlobalDate(callDay.date)}}</option>
                                                </select>
                                            </div>
                                            </label>
                                        </div>
                                    <!-- <div class="form-group o-no-margin">
                                        <label class="common-label-text">Clone From:</label>
                                        <label class="common-label-input">
                                        <el-date-picker
                                            name="Start"
                                            class="custom_date"
                                            v-validate="{ required: true}"
                                            v-model="editCallData.start"
                                            type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Pick a day">
                                        </el-date-picker>

                                        </label>
                                    </div> -->
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group o-no-margin">
                                            <label class="common-label-text">Insert Mode:</label>
                                            <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="advanceCloneData.insertMode">
                                                    <option value="1">Merge calls into existing calls</option>
                                                    <option value="0">Replace all existing calls</option>

                                                </select>
                                            </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-10">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow">
                                        <div class="call-clone-table-head">
                                            <h4 class="ps1">Clone From</h4>
                                            <div class="o-floar-right">
                                                <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                <a href="javascript: void(0)" @click="selectAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</a>
                                                <a href="javascript: void(0)" @click="selectNoneAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</a>
                                            </div>

                                        </div>
                                        <div class="call-clone-table-body">
                                            <div class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    &nbsp;
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Start time
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    End time
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Skill
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Employee
                                                </div>
                                            </div>
                                            <div v-for="(call, callIndex) in advanceCloneData.callUnderSelectedDay" :key="callIndex" class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <input type="checkbox" name="o4" :value="call.id" v-model="advanceCloneData.selectedcallsToClone">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getTime(call.start)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getTime(call.end)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{call.skill.name}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{(call.employee != null)?call.employee.employable.first_name + " " + call.employee.employable.last_name:"Not Assign"}}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-5">
                            <div class="row">
                                <!-- <div class="col-sm-12">
                                    <div class="call-clone-table-head">
                                        <div class="form-group o-no-margin">
                                            <label class="common-label-text common-label-text--fullwidth">Assignments:</label>
                                            <label class="common-label-input--fullwidth o-custom-dropdown">
                                                <select class="form-control" v-model="advanceCloneData.assignments">
                                                    <option value="1">Preserve call assignments</option>
                                                    <option value="0">Clear call assignments</option>
                                                </select>
                                                <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-sm-12">
                                    <div class="call-clone-table-head">
                                        <hr class="o-common-separetor o-no-margin" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow-large">
                                        <div class="call-clone-table-head">
                                            <h4 class="ps1">Clone To</h4>
                                            <div class="o-floar-right">
                                                <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                <a href="javascript: void(0)" @click="selectAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'allDay')?'o-filter-active':''">All</a>
                                                <a href="javascript: void(0)" @click="selectNoneAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'noneDay')?'o-filter-active':''">None</a>
                                            </div>

                                        </div>
                                        <div class="call-clone-table-body">
                                            <div class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    &nbsp;
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Date
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Calls
                                                </div>

                                            </div>
                                            <div v-for="(dayCall,dayCallIndex) in callDaysForJob" :key="dayCallIndex" class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <input type="checkbox" name="o4" :value="dayCall.date" v-model="advanceCloneData.selectedDaysToClone">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getGlobalDate(dayCall.date)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{dayCall.calls.length}} calls
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeAdvanceClone()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveAdvanceClone()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Clone Calls</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="viewEmployee"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeViewEmployee()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Assigned Employee List</h1>
                        </div>

                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-5 c-margin-top-5">
                            <div class="row">

                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow-large">
                                        <div class="o-modal-empList">

                                            <div v-if="empList.employee != null" v-for="(empList,empListIndex) in viewEmpList" :key="empListIndex" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 empModal-table-align">
                                                <div class="calls-table-row">
                                                    <div class="calls-table-cell">
                                                        <div><!-- class="table-td-border-right" -->
                                                            <div class="o-accordion-subtext o-rowtable-text">
                                                                <span>Employee</span>
                                                                <div>{{empList.employee.employable.first_name + " " + empList.employee.employable.last_name}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="calls-table-cell">
                                                        <div class="calls-table-cell-inner-table">
                                                            <div class="o-no-padding">
                                                                <!-- <a @click="clearAssign(empList)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-minus-circle" aria-hidden="true"></i> Clear Assign</a> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="modal-footer text-center">
                            <!-- <ul class="o-filter-area">
                                <li>
                                    <a @click="closeAdvanceClone()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a @click="saveAdvanceClone()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Clone Calls</a>
                                </li>
                            </ul> -->
                        </div>

                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../../services.js';
    import {
        bus
    } from '../../../main';
    import {
        scroller
    } from 'vue-scrollto/src/scrollTo';
    export default {
        data() {
            const dataProps = {
                selectedScrollDate: "",
                polling: null,
                userClientID:'',
                jobAccessStatus:null,
                selectedFilter: 'none',
                selectedFilterDay: 'noneDay',
                viewEmpList: [],
                selectedSortType: '',
                editBulkcall: {
                    startDate: '',
                    startTime: '',
                    endDate: '',
                    endTime: '',
                    skill: '',
                    skillNane: '',
                    notes: '',
                    rate:''
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        //vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                afterAPI: false,
                calls: [],
                callsFilter: {
                    start: true,
                    end: true,
                    position: true
                },
                loading: false,
                positions: [],
                callDaysForJob: [],
                callIds: [],
                cloneData: {
                    assignments: false,
                    cloneFrom: '',
                    closeTo: '',
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                advanceCloneData: {
                    selectedDaysToClone: [],
                    selectedcallsToClone: [],
                    insertMode: 1,
                    assignments: 0,
                    callUnderSelectedDay: [],
                },

            };
            return dataProps;
        },
        props: {
            sortType: {
                type: String,
                required: true
            },
            job:{
                type: Object,
                required: true  
            }
        },
        watch: {
            sortType: function(newData) {
                this.selectedSortType = newData;
                this.sortCalls();
                //console.log(newData);
            },
            job: function(newData){
                this.job=newData;
                // console.log(this.job);
                this.userClientID=newData.client_id;
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                selectedJobTitle: 'selectedJobTitle',
                getLastPositionId: 'getLastPositionId',
            })
        },
        methods: {
            addBulkCall(date='') {
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId,
                    query: date!=''?{ date: date }: null
				});
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            noteBtnActive(group){
                let flag = false;
                group.call.forEach(item =>{
                    if(item.notes){
                        flag = true;
                        return false;
                    }
                })
                return flag;
            },
            changeSortType() {
                // console.log('sortTypeChanged: ' + this.selectedSortType);
                bus.$emit('sortTypeChanged', this.selectedSortType);
            },
            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
                //var date = str.split(" ");
                //return date[0];
            },
            onSelectScrollTo(e) {
                // console.log(e);
                
                //console.log(e.target.value);
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },
            checkCallEditStatus(unassigned_call){
                if(unassigned_call>0 && this.jobAccessStatus != 'View Access'){
                   return true;
                }
                return false;
                
            },
            getGlobalDate(dateTime) {
                return dateTimeConvert.globalDate(dateTime);
                // //var date = dateTimeConvert.extractDateOnly(dateTime);
                // return dateTimeConvert.extractDateOnly(dateTime);
            },
            selectAllDay() {
                this.selectedFilterDay = 'allDay';
                let self = this;
                this.callDaysForJob.forEach(function(call) {
                    self.advanceCloneData.selectedDaysToClone.push(call.date);
                    //console.log(emp.employable.id);
                });
            },
            selectNoneAllDay() {
                this.selectedFilterDay = 'noneDay';
                this.advanceCloneData.selectedDaysToClone = [];
            },
            selectAllCall() {
                this.selectedFilter = 'all';
                let self = this;
                this.advanceCloneData.callUnderSelectedDay.forEach(function(call) {
                    self.advanceCloneData.selectedcallsToClone.push(call.id);
                    //console.log(emp.employable.id);
                });
            },
            selectNoneAllCall() {
                this.selectedFilter = 'none';
                this.advanceCloneData.selectedcallsToClone = [];
            },
            sortCalls() {
                let self = this;
                switch (this.selectedSortType) {
                    case 'start':
                        var _vm = this;
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }   
                            });
                        }

                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {
                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                         var dateA = moment(a.start);
                                        var dateB = moment(b.start);
                                        return dateA > dateB ? 1 : -1;
                                    });
                                }
                            });
                        }
                        break;
                    case 'skill':
                        var _vm = this;
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }   
                            });
                        }

                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {

                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                        if (a.skills[0].priotiy < b.skills[0].priotiy) return -1;
                                        if (a.skills[0].priotiy > b.skills[0].priotiy) return 1;
                                        return 0;
                                    });
                                }
                            });
                        }                        
                        break;

                    case 'status':
                        var _vm = this;                        
                        for (let key in this.calls) {
                            this.calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }   
                            });
                        }
                        for (let key in this.calls) {
                            var promises = this.calls[key].map((value) => {
                                if(value.call) {
                                    value.call.sort(function(a, b) {
                                        if(a.employee && b.employee) {
                                            if(a.employee["seniority"] >=0 && b.employee["seniority"] >=0){
                                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                                if (a.employee.seniority == b.employee.seniority) {
                                                    return _vm.sortByEmpName(a,b);
                                                }
                                            } else {
                                                return -1;                                              
                                            }
                                        }else if(!a.employee) {
                                            return -1;
                                        }else if(!b.employee) {
                                            return 0;
                                        }
                                        return -1;
                                    });
                                }
                            });
                            Promise.all(promises).then(function(results) {
                                if(results) {
                                    _vm.calls[key].sort((a,b) => {
                                        if (a.unassigned >= b.unassigned) return -1;
                                        if (a.unassigned < b.unassigned) return 1;
                                    });
                                }
                            });
                        }
                        break;
                    default:
                        console.log("default case..");
                }
            },

            sortByEmpName(a,b) {
                if(this.empSort == 'fname_desc') {                                                        
                    if(a.employee&&a.employee.employable && a.employee.employable.last_name && b.employee&&b.employee.employable && b.employee.employable.last_name) {
                        var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    }
                } else {
                    if(a.employee&&a.employee.employable && a.employee.employable.first_name && b.employee&&b.employee.employable && b.employee.employable.first_name) {
                        var nameA = a.employee.employable.first_name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.employee.employable.first_name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                    }
                }
            },

            extractDateOnly(dateTime) {
                return dateTime.split(" ")[0];
            },
            deleteBulkCall(calls) {
                let self = this;
                let callIds = [];
                calls.call.forEach(function(call) {
                    callIds.push(call.id);
                    //console.log(emp.employable.id);
                });
                //console.log(callIds);
                this.$confirm('CALL will be removed from the records of CALL LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('employer/deleteBulkCall', {
                        'callIds': JSON.stringify(callIds),
                        'userId':this.userID,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getBulkCalls();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            closeEditBulk() {
                this.$modal.hide("edit-bulk");
            },
            editBulk(call) {
                this.$modal.show("edit-bulk");
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        this.callDaysForJob = res.data.result;
                        this.$Progress.finish();

                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                this.getPositions();
                //console.log(call.skills[0].id);
                this.editBulkcall.startDate = call.called_at.split(" ")[0];
                this.editBulkcall.startTime = this.getTime(call.start);
                this.editBulkcall.endDate = call.end.split(" ")[0];
                this.editBulkcall.endTime = this.getTime(call.end);
                this.editBulkcall.skill = call.skills[0].id;
                this.editBulkcall.skillNane = call.skills[0].name;
                this.editBulkcall.notes=call.notes;
                this.editBulkcall.rate=call.rate;
                //console.log('editBulkcall',this.editBulkcall);
                let self = this;
                this.callIds = [];
                call.call.forEach(function(singleCall) {
                    self.callIds.push(singleCall.id);
                    //console.log(emp.employable.id);
                });

            },
            saveEditCall() {
                //moment("2018-06-07 02:10 pm").format('YYYY-MM-DD HH:mm:ss');
                let formData = {
                    end: moment(this.editBulkcall.endDate + " " + this.editBulkcall.endTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                    start: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                    skill_id: this.editBulkcall.skill,
                    job_id: atob(this.$route.params.jobId),
                    called_at: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime, ["YYYY-MM-DD h:mm a"]).format('YYYY-MM-DD HH:mm:ss'),
                    ids: JSON.stringify(this.callIds),
                    start_status: (this.callsFilter.start) ? 1 : 0,
                    end_status: (this.callsFilter.end) ? 1 : 0,
                    skill_status: (this.callsFilter.position) ? 1 : 0,
                    notes:this.editBulkcall.notes,
                    rate : this.editBulkcall.rate,
                }
                if (moment(this.editBulkcall.startTime, 'HH:mm A').format('HH:mm:ss')>=moment(this.editBulkcall.endTime, 'HH:mm A').format('HH:mm:ss')) {
                    formData.end=moment(formData.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                    //console.log("date Incrised",formData.end);
                }


               // let formData = {
                //     end: moment(this.editBulkcall.endDate + " " + this.editBulkcall.endTime).format('YYYY-MM-DD HH:mm:ss'),
                //     start: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime).format('YYYY-MM-DD HH:mm:ss'),
                //     skill_id: this.editBulkcall.skill,
                //     job_id: atob(this.$route.params.jobId),
                //     called_at: moment(this.editBulkcall.startDate + " " + this.editBulkcall.startTime).format('YYYY-MM-DD HH:mm:ss'),
                //     ids: JSON.stringify(this.callIds),
                //     start_status: (this.callsFilter.start) ? 1 : 0,
                //     end_status: (this.callsFilter.end) ? 1 : 0,
                //     skill_status: (this.callsFilter.position) ? 1 : 0,
                //     notes:this.editBulkcall.notes,
                //     rate : this.editBulkcall.rate,
                // }
                // let formData = {
                //     end: this.editBulkcall.endDate + " " + dateTimeConvert.convertTo24Hours(this.editBulkcall.endTime),
                //     start: this.editBulkcall.startDate + " " + dateTimeConvert.convertTo24Hours(this.editBulkcall.startTime),
                //     skill_id: this.editBulkcall.skill,
                //     job_id: atob(this.$route.params.jobId),
                //     called_at: this.editBulkcall.startDate + " " + dateTimeConvert.convertTo24Hours(this.editBulkcall.startTime),
                //     ids: JSON.stringify(this.callIds),
                //     start_status: (this.callsFilter.start) ? 1 : 0,
                //     end_status: (this.callsFilter.end) ? 1 : 0,
                //     skill_status: (this.callsFilter.position) ? 1 : 0,
                //     notes:this.editBulkcall.notes,
                //     rate : this.editBulkcall.rate,
                // }
                //console.log(formData,this.editBulkcall);
                service.put('employer/editBulkCall', formData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("edit-bulk");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Edited Successfully.',
                            type: 'success'
                        });
                        this.getBulkCalls();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            getPositions() {
                //console.log("getPositions called..");
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.positions = res.data.result.data;
                    //console.log(this.positions);
                }).catch((err) => {
                    console.log(err);
                });
            },
            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            getDate(dateTime) {
                //return dateTimeConvert.globalDate(dateTime);
                return dateTimeConvert.extractDateOnly(dateTime);
            },
            getGlobalDate(dateTime) {
                return dateTimeConvert.globalDate(dateTime);
                // //var date = dateTimeConvert.extractDateOnly(dateTime);
                // return dateTimeConvert.extractDateOnly(dateTime);
            },
            bulkAssign(call, id) {
                this.$store.dispatch('setBulkCall', call);
                this.$store.dispatch('setLastPositionId', id);
                // this.$router.push('bulkAssign');
                // this.$router.push({
                //     path: `/bulkAssign/` + this.$route.params.jobId
                // });
                this.$router.push({
                    path: `/bulkAssignCustom/` + this.$route.params.jobId
                });
            },
            async getBulkCalls() {
                this.loading = true;
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'start': (this.callsFilter.start) ? 1 : 0,
                    'end': (this.callsFilter.end) ? 1 : 0,
                    'skill': (this.callsFilter.position) ? 1 : 0
                };
                this.calls = [];
                this.$Progress.start();
                this.afterAPI = false;
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                await service.get('call/' + atob(this.$route.params.jobId) + '/group', header)
                .then((res) => {
                    this.calls = res.data.result;
                    bus.$emit('onUpdateCallList', this.calls);
                    this.$Progress.finish();
                    this.loading = false;
                    //console.log(this.calls);
                    this.afterAPI = true;
                    this.sortCalls();
                    if(this.getLastPositionId && this.getLastPositionId !=''){
                        let self=this;
                        setTimeout(() => {
                            var positionID='#'+self.getLastPositionId;
                            //console.log(positionID);
                            const firstScrollTo = scroller();
                            firstScrollTo(positionID, 200, {
                                offset: -150
                            });
                            self.$store.dispatch('setLastPositionId', '');
                        }, 1000); 
                    }else {
                        window.scrollTo(scrollPositionX, scrollPositionY);
                        document.body.scrollPositionY;
                    }
                    

                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading = false;
                    this.afterAPI = true;
                });
            },

            async refreshBulkCalls() {
                // this.loading = true;
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'start': (this.callsFilter.start) ? 1 : 0,
                    'end': (this.callsFilter.end) ? 1 : 0,
                    'skill': (this.callsFilter.position) ? 1 : 0
                };
                //console.log(header);
                this.$Progress.start();
                this.afterAPI = false;
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                await service.get('call/' + atob(this.$route.params.jobId) + '/group', header)
                .then((res) => {
                    this.calls = [];
                    this.calls = res.data.result;
                    bus.$emit('onUpdateCallList', this.calls);
                    this.$Progress.finish();
                    this.loading = false;
                    //console.log(this.calls);
                    this.afterAPI = true;
                    this.sortCalls();
                    if(this.getLastPositionId && this.getLastPositionId !=''){
                        let self=this;
                        setTimeout(() => {
                            var positionID='#'+self.getLastPositionId;
                            //console.log(positionID);
                            const firstScrollTo = scroller();
                            firstScrollTo(positionID, 200, {
                                offset: -150
                            });
                            self.$store.dispatch('setLastPositionId', '');
                        }, 1000); 
                    }else {
                        window.scrollTo(scrollPositionX, scrollPositionY);
                        document.body.scrollPositionY;
                    }
                    

                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading = false;
                    this.afterAPI = true;
                });
            },

            onInputChangeCheckbox() {
                this.getBulkCalls();
            },

            openCloneModal(cloneFrom) {
                this.$modal.show("call-clone");
                //this.cloneData.closeTo = this.job.start.split(" ")[0];
                this.cloneData.cloneFrom = cloneFrom.split(" ")[0];
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        //console.log(this.advanceCloneData.callUnderSelectedDay);
                        this.callDaysForJob = res.data.result;
                        this.cloneData.closeTo = this.callDaysForJob[0].date;
                        this.$Progress.finish();
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
            },
            cloneCall() {
                let fromData = {
                    from: this.cloneData.cloneFrom + " " + Date().slice(16, 24),
                    to: this.cloneData.closeTo, // + " " + Date().slice(16, 24),
                    job_id: this.job.id,
                    assign: (this.cloneData.assignments) ? 1 : 0,
                    user_id: this.userID
                };
                //console.log(fromData);
                service.post('call/clone', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("call-clone");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Clone Successfully.',
                            type: 'success'
                        });
                        this.getBulkCalls();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            closeCloneModal() {
                this.$modal.hide("call-clone");
            },
            openAdvanceClone(selectedCloneTo) {
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        //console.log(this.advanceCloneData.callUnderSelectedDay);
                        this.callDaysForJob = res.data.result;
                        //console.log("Data", this.callDaysForJob);
                        for (let i = 0; i < this.callDaysForJob.length; i++) {
                            if (this.callDaysForJob[i].calls.length > 0) {
                                if (this.callDaysForJob[i].date.split(" ")[0] == selectedCloneTo) {
                                    this.advanceCloneData.callUnderSelectedDay = this.callDaysForJob[i].calls;
                                }
                            }
                        }
                        //callUnderSelectedDay
                        this.$Progress.finish();
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                this.$modal.show("advance-call-clone");
            },
            closeAdvanceClone() {
                this.$modal.hide("advance-call-clone");
            },
            saveAdvanceClone() {

                let fromData = {
                    call_ids: JSON.stringify(this.advanceCloneData.selectedcallsToClone),
                    clone_to_dates: JSON.stringify(this.advanceCloneData.selectedDaysToClone),
                    insert_mode: this.advanceCloneData.insertMode,
                    assign: this.advanceCloneData.assignments,
                    job_id: atob(this.$route.params.jobId),
                    user_id: this.userID
                };
                //console.log(fromData);
                //console.log(this.advanceCloneData);
                service.post('call/advanceCall', fromData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Clone Successfully.',
                        type: 'success'
                    });
                    this.getBulkCalls();
                    this.$modal.hide("advance-call-clone");
                }).catch((err) => {
                    console.log(err);
                });
            },
            goToViewEmployee(call) {
                this.$modal.show("viewEmployee");
                this.viewEmpList = call.call;
                //console.log("GET BULK CALL", this.viewEmpList);
            },
            closeViewEmployee() {
                this.$modal.hide("viewEmployee");
            },
            clearAssign(empList) {
                service.del('call/' + empList.id + '/assign', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,
                }).
                then((res) => {
                    this.$modal.hide("viewEmployee");
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call cleared successfully.',
                        type: 'success'
                    });
                    //this.getAllCalls();
                    this.getBulkCalls();
                }).catch((err) => {
                    console.log(err);
                });
            },

            pollData () {   
                this.polling = setInterval(() => {
                    // console.log(document.visibilityState);
                    if(document.visibilityState === 'visible'){
                        this.timerState = "Started"
                    }else {
                        this.timerState = "Paused"
                    }
                    if (this.timerState === "Started") {
                        // console.log("Call Api");
                        this.refreshBulkCalls();
                    }
                }, 60000);
            }
            
        },
        created() {
            this.jobAccessStatus=this.job.client.employer[0].status? this.job.client.employer[0].status.name: '';
            this.userClientID=this.job.client_id;
            this.selectedSortType =this.sortType;
            this.getBulkCalls();
            bus.$on('onSaveNewCall', (data) => {
                this.getBulkCalls();
            });
            this.pollData();
        },
        mounted() {
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },
        beforeDestroy () {
            clearInterval(this.polling)
        }

    }

</script>
<style scoped>
.w-100 {
    width: 100px;
}
tbody, td {
    vertical-align: middle!important;
}

td a {
    margin: 2px!important;
}
.view-bulk-call-list-scroll{
    overflow-y: scroll;
    max-height: 90px;
}
.view-bulk-call-list-scroll > div{
    font-size: 12px;
}
.confirm-check-icon-style{
    background-color: green;
    border-radius: 100%;
    color: white;
    padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/calls/employer/bulkCalls.vue